// extracted by mini-css-extract-plugin
export default {"root":"layout-module--root--12065"};